"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ListingCategory;
(function (ListingCategory) {
  ListingCategory["BUY"] = "BUY";
  ListingCategory["RENT"] = "RENT";
  ListingCategory["SHARE"] = "SHARE";
  ListingCategory["DEVELOPMENTS"] = "DEVELOPMENTS";
})(ListingCategory || (ListingCategory = {}));
var _default = exports.default = ListingCategory;